// extracted by mini-css-extract-plugin
export var questionBox = "_5u-0";